@if (form) {
  <form [formGroup]="form" (validSubmit)="save()">
    <div class="row form-section">
      <div class="col">
        <app-form-control [columnLayout]="true">
          <app-form-label [required]="true"> Name </app-form-label>
          <input
            type="text"
            class="form-control"
            [class.is-invalid]="
              form.controls.name.touched && form.controls.name.invalid
            "
            [class.border-warning]="form.controls.name.pending"
            formControlName="name"
          />
          @if (form.controls.name.hasError('required')) {
            <div class="invalid-feedback">Name is required</div>
          }
          @if (form.controls.name.getError('maxlength'); as error) {
            <div class="invalid-feedback">
              Name must be less than {{ error.requiredLength }} characters
            </div>
          }
        </app-form-control>

        <app-form-control [columnLayout]="true">
          <app-form-label> Description </app-form-label>
          <input
            type="text"
            [ngClass]="{
              'is-invalid':
                form.controls.description.touched &&
                form.controls.description.invalid,
            }"
            class="form-control"
            formControlName="description"
          />
          <div class="invalid-feedback">The description is not valid</div>
        </app-form-control>

        <app-form-control [columnLayout]="true">
          <app-form-label> Parent Group </app-form-label>

          <app-parent-group-typeahead
            [control]="form.controls.parentGroup"
          ></app-parent-group-typeahead>
        </app-form-control>
      </div>
    </div>

    <div class="d-flex justify-content-end mt-4">
      <button class="btn btn-outline" type="button" (click)="onCancel()">
        Cancel
      </button>
      <button class="btn btn-primary ms-2" type="submit">Save</button>
    </div>
  </form>
}
